<template>
  <div class="container">
    <ScanReturnTicketList
      v-if="step === 0"
      :routeFlag="routeFlag"
      @nexStep="nexStep"
      @scan="scan"
    />
    <ScanReturnTicket
      v-if="step === 1"
      :productOrder="productOrder"
      @prevStep="prevStep"
      @nexStep="nexStep"
    />
  </div>
</template>

<script>
import ScanReturnTicketList from './list';
import ScanReturnTicket from './scan';

export default {
  name: 'ScanReturnTicketIndex',
  components: {
    ScanReturnTicketList,
    ScanReturnTicket,
  },
  data() {
    return {
      step: 0,
      productOrder: '',
      routeFlag: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.routeFlag = !vm.routeFlag;
    })
  },
  methods: {
    scan(productOrder) {
      this.productOrder = productOrder;
    },
    prevStep() {
      this.step -= 1;
    },
    nexStep() {
      this.step += 1;
      this.step %= 2;
    },
  },
};
</script>

<style scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }
</style>
